import defaultTheme from './defaultTheme';
const marvelTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#e81c23', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#e81c23', background: '#e81c23' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#e81c23' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#e81c23', border: '#e81c23', background: '#e81c23' }), field: {
        focus: '#e81c23',
        label: '#e81c23',
        icon: '#e81c23',
    } });
export default marvelTheme;
